'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _tags = require('redux/modules/tags');

var _containers = require('../containers');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchData(getState, dispatch) {
  var state = getState().types;
  return dispatch((0, _tags.index)(state.showAll));
}

var TagsContainer = (_dec = (0, _connectData2.default)(fetchData), _dec(_class = function (_Component) {
  (0, _inherits3.default)(TagsContainer, _Component);

  function TagsContainer() {
    (0, _classCallCheck3.default)(this, TagsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (TagsContainer.__proto__ || (0, _getPrototypeOf2.default)(TagsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(TagsContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBodyClassname2.default,
        { className: 'tags' },
        _react2.default.createElement(_containers.EntitiesContainer, { entity: 'tags' })
      );
    }
  }]);
  return TagsContainer;
}(_react.Component)) || _class);
exports.default = TagsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TagsContainer.js
// module id = 1188
// module chunks = 0